import { useEffect } from 'react';
import { loadScript } from '@philips-internal/oswald-ui-utils';
import { AnalyticsProvider } from './analytics-constants.js';
const scriptTagIdentifier = 'oswald-analytics';
const sourcesByProvider = {
    [AnalyticsProvider.GOOGLE]: 'https://www.googletagmanager.com/gtag/js?id=',
};
function Analytics(props) {
    const scriptSrc = sourcesByProvider[props.provider];
    if (!scriptSrc) {
        return null;
    }
    useEffect(() => {
        let scriptElement;
        loadScript({
            async: true,
            defer: true,
            identifier: scriptTagIdentifier,
            src: `${scriptSrc}${props.id}`,
        })
            .then(ref => scriptElement = ref)
            .catch(error => {
            throw new Error(`[Analytics]: ${error?.message}`);
        });
        return () => scriptElement?.remove();
    }, [props.provider, props.id]);
    return null;
}
export { Analytics, };
//# sourceMappingURL=analytics.js.map